"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MMSImg = void 0;
var eventemitter3_1 = require("eventemitter3");
var __1 = require("..");
var version_json_1 = require("../../version.json");
var uuid_1 = require("uuid");
var endpoint_sdk_1 = require("@shopee-mmc/endpoint-sdk");
var utils_1 = require("./utils");
var report_1 = require("../report");
var axios_1 = require("axios");
var USSImg_1 = require("./USSImg");
var WCSImg_1 = require("./WCSImg");
var types_1 = require("../types");
var MMSImg = /** @class */ (function () {
    function MMSImg(options) {
        this.options = options;
        this.event = new eventemitter3_1.EventEmitter();
        this.serviceMap = {
            shopeeuss: undefined,
            wscloud: undefined,
            awscloud: undefined
        };
        options.env = options.env || __1.IEnv.STAGING; // set default env to staging
    }
    /**
     * convert data64 to File object
     * Example: "data:image/jpeg;base64,xxxxxxxxxx" => File
     * @param dataurl
     * @param filename
     */
    MMSImg.dataURLtoFile = function (dataurl, filename) {
        var arr = dataurl.split(',');
        if (arr.length !== 2)
            throw new Error('dataURL is normative');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = window.atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };
    Object.defineProperty(MMSImg.prototype, "strategy", {
        // 获取策略
        get: function () {
            return __assign({ ver: this._strategy.ver, api_timeout: this._strategy.api_timeout }, // this._strategy.configs[this.options.biz] || this._strategy.configs[100]
            this._strategy.configs.upload // 默认使用biz为100的配置
            );
        },
        enumerable: false,
        configurable: true
    });
    MMSImg.prototype.genCommonBody = function (biz) {
        var requestId = (0, uuid_1.v4)().replace(/-/g, '');
        var _biz = biz !== null && biz !== void 0 ? biz : this.options.biz;
        return {
            version: 1,
            sign: (0, utils_1.getSignature)(requestId, _biz),
            biz: _biz,
            app_version: 'mms-' + version_json_1.version,
            sdk_version: 'mms-' + version_json_1.version,
            os_type: 2,
            request_id: requestId,
            device_model: navigator.userAgent,
            client_region: this.options.country,
            uid: this.options.uid
        };
    };
    MMSImg.prototype.genAxiosInstance = function (timeout, times, delay) {
        return axios_1.default.create({
            timeout: timeout !== null && timeout !== void 0 ? timeout : 0,
            adapter: (0, utils_1.retryAdapterEnhancer)(axios_1.default.defaults.adapter, {
                times: times !== null && times !== void 0 ? times : 3,
                delay: delay !== null && delay !== void 0 ? delay : 0
            })
        });
    };
    MMSImg.prototype.preupload = function (imgCount) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var commonBody, startTime, res, data, error_1, actionId;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commonBody = this.genCommonBody();
                        startTime = Date.now();
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.genAxiosInstance(this.strategy.api_timeout, this.strategy.retry_count, this.strategy.backoff_time).post("https://api.mms.".concat(types_1.IEnvDomain[this.options.env], "shopee.").concat(__1.ICountryDomain[this.options.country], "/uploadapi/api/v1/image/preupload"), {
                                _header: commonBody,
                                count: imgCount
                            })];
                    case 2:
                        res = _d.sent();
                        data = res.data.data;
                        data.services = data.services.map(function (item, idx) { return (__assign(__assign({}, item), { token: (0, utils_1.decryptToken)(item.token, commonBody.request_id), index: idx })); });
                        this.report.ImgPreuploadEvent({
                            actionId: this.canceled ? 3002 : 0,
                            serviceLen: data.services.length,
                            firstServiceId: data.services[0].service_id,
                            imgIdsLen: data.img_ids.length,
                            cost: Date.now() - startTime,
                            strategyVer: this.strategy.ver,
                            retryCount: res.retry_count
                        });
                        return [2 /*return*/, data];
                    case 3:
                        error_1 = _d.sent();
                        actionId = (_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : 3001;
                        if ((0, utils_1.isTimeout)(error_1))
                            actionId = 3001;
                        this.report.ImgPreuploadEvent({
                            actionId: this.canceled ? 3002 : actionId,
                            cost: Date.now() - startTime,
                            strategyVer: this.strategy.ver,
                            retryCount: this.strategy.retry_count
                        });
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // 从服务端获取策略配置
    MMSImg.prototype.getStrategy = function () {
        var endpoint = new endpoint_sdk_1.ENDPOINT({
            biz: this.options.biz,
            country: __1.ICountry.SG,
            // @ts-ignore // todo 发版后移除注释
            env: this.options.env,
            uid: this.options.uid
        });
        var res = endpoint.getStrategy();
        if (res) {
            var ver = res.ver, api_timeout = res.api_timeout, configs = res.configs, 
            // todo 移除endpoint_cron相关字段
            _a = res.endpoint_cron, interval = _a.interval, pull_time = _a.pull_time, ttl = _a.ttl;
            this._strategy = { ver: ver, interval: interval, pull_time: pull_time, ttl: ttl, api_timeout: api_timeout, configs: configs };
        }
    };
    MMSImg.prototype.notify = function (params) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            var startTime, res, error_2, actionId;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        startTime = Date.now();
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.genAxiosInstance(this.strategy.api_timeout, this.strategy.retry_count, this.strategy.backoff_time).post("https://api.mms.".concat(types_1.IEnvDomain[this.options.env], "shopee.").concat(__1.ICountryDomain[this.options.country], "/uploadapi/api/v1/image/notify"), {
                                _header: this.genCommonBody(),
                                service_id: params.serviceId,
                                img_id: params.imgId,
                                url: params.url,
                                fsize: params.fsize,
                                finish_time: params.finishTime
                            }, {
                                headers: {
                                    Authorization: params.token
                                }
                            })];
                    case 2:
                        res = _g.sent();
                        this.report.ImgNotifyEvent({
                            actionId: this.canceled ? 5002 : 0,
                            serviceId: params.serviceId,
                            imgid: params.imgId,
                            code: res.data.code,
                            cost: Date.now() - startTime,
                            strategyVer: this.strategy.ver,
                            retryCount: res.retry_count
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _g.sent();
                        actionId = (_c = (_b = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : 5001;
                        if ((0, utils_1.isTimeout)(error_2))
                            actionId = 5001;
                        this.report.ImgNotifyEvent({
                            actionId: this.canceled ? 5002 : actionId,
                            serviceId: params.serviceId,
                            imgid: params.imgId,
                            code: (_f = (_e = (_d = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.code) !== null && _f !== void 0 ? _f : 5001,
                            cost: Date.now() - startTime,
                            strategyVer: this.strategy.ver,
                            retryCount: this.strategy.retry_count
                        });
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MMSImg.prototype.base64Upload = function (dataUrls) {
        if (dataUrls.length <= 0) {
            throw new Error('there is no dataUrl, at least one');
        }
        this.upload(dataUrls.map(function (url) { return MMSImg.dataURLtoFile(url); }));
    };
    MMSImg.prototype.upload = function (files) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (files.length <= 0) {
                    throw new Error('there is no file, at least 1 file');
                }
                this.report = new report_1.Report({
                    country: this.options.country,
                    biz: this.options.biz,
                    env: this.options.env,
                    sdkVersion: 'mms-' + version_json_1.version,
                    uid: this.options.uid,
                    reportNoLimit: true
                });
                this.files = files;
                this.canceled = false;
                return [2 /*return*/];
            });
        });
    };
    MMSImg.prototype.createService = function (service) {
        var _this = this;
        var onProgressCB = function (info) {
            return _this.event.emit(__1.UploaderEvents.imageProgress, info);
        };
        switch (service.service_id) {
            case __1.ServiceID.shopeeuss:
                this.curService = new USSImg_1.default(__assign(__assign({}, service), { strategy: this.strategy, onProgressCB: onProgressCB }));
                this.serviceMap[__1.ServiceID.shopeeuss] = this.curService;
                break;
            case __1.ServiceID.wscloud:
                this.curService = new WCSImg_1.WCSImg(__assign(__assign({}, service), { strategy: this.strategy, onProgressCB: onProgressCB }));
                this.serviceMap[__1.ServiceID.wscloud] = this.curService;
                break;
            default:
                break;
        }
    };
    MMSImg.prototype.done = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response, uploadMsg, i, notifyFail, _i, _b, service, serviceId, fileTransferEventCommon, startTime, url, fail, info, error_3, actionId, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        response = [];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, , 16, 17]);
                        this.getStrategy();
                        return [4 /*yield*/, this.preupload(this.files.length)];
                    case 2:
                        uploadMsg = _d.sent();
                        uploadMsg.services = uploadMsg.services.map(function (service, index) { return (__assign(__assign({}, service), { index: index })); });
                        i = 0;
                        notifyFail = false // notify失败代表用户上传失败
                        ;
                        _i = 0, _b = uploadMsg.services;
                        _d.label = 3;
                    case 3:
                        if (!(_i < _b.length)) return [3 /*break*/, 15];
                        service = _b[_i];
                        if (this.canceled || i >= this.files.length || notifyFail)
                            return [3 /*break*/, 15];
                        serviceId = service.service_id;
                        this.createService(service);
                        _d.label = 4;
                    case 4:
                        if (!(i < this.files.length && !this.canceled)) return [3 /*break*/, 14];
                        fileTransferEventCommon = {
                            serviceId: service.service_id,
                            serviceIdx: service.index,
                            imgid: uploadMsg.img_ids[i],
                            strategyVer: this.strategy.ver
                        };
                        startTime = Date.now();
                        url = void 0;
                        fail = false;
                        _d.label = 5;
                    case 5:
                        _d.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.serviceMap[serviceId].upload({
                                file: this.files[i],
                                imgId: uploadMsg.img_ids[i],
                                imgIndex: i
                            })];
                    case 6:
                        info = _d.sent();
                        url = info.url;
                        this.event.emit(__1.UploaderEvents.imageUpload, info);
                        response.push(info);
                        this.report.ImgFileTransferEvent(__assign(__assign({}, fileTransferEventCommon), { actionId: this.canceled ? 4003 : 0, code: 0, extendId: uploadMsg.img_ids[i], fsize: this.files[i].size, cost: Date.now() - startTime }));
                        return [3 /*break*/, 8];
                    case 7:
                        error_3 = _d.sent();
                        fail = true;
                        actionId = 4001;
                        if (axios_1.default.isCancel(error_3))
                            actionId = 4003;
                        this.report.ImgFileTransferEvent(__assign(__assign({}, fileTransferEventCommon), { actionId: this.canceled ? 4003 : actionId, code: this.canceled ? 4003 : ((_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.data.code) || 4001, cost: Date.now() - startTime }));
                        return [3 /*break*/, 8];
                    case 8:
                        if (!!fail) return [3 /*break*/, 12];
                        _d.label = 9;
                    case 9:
                        _d.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, this.notify({
                                serviceId: service.service_id,
                                imgId: uploadMsg.img_ids[i],
                                token: service.token,
                                url: url,
                                fsize: this.files[i].size,
                                finishTime: Date.now()
                            })];
                    case 10:
                        _d.sent();
                        return [3 /*break*/, 12];
                    case 11:
                        _c = _d.sent();
                        fail = true;
                        notifyFail = true;
                        response.pop();
                        return [3 /*break*/, 12];
                    case 12:
                        if (fail) {
                            return [3 /*break*/, 14];
                        }
                        _d.label = 13;
                    case 13:
                        i++;
                        return [3 /*break*/, 4];
                    case 14:
                        _i++;
                        return [3 /*break*/, 3];
                    case 15: return [3 /*break*/, 17];
                    case 16:
                        this.report.report();
                        return [7 /*endfinally*/];
                    case 17: return [2 /*return*/, this.canceled ? [] : response];
                }
            });
        });
    };
    MMSImg.prototype.cancel = function () {
        var _a;
        (_a = this.curService) === null || _a === void 0 ? void 0 : _a.cancel();
        this.canceled = true;
    };
    MMSImg.prototype.on = function (event, cb) {
        this.event.on(event, cb);
    };
    MMSImg.prototype.off = function (event, cb) {
        this.event.off(event, cb);
    };
    MMSImg.prototype.once = function (event, cb) {
        this.event.once(event, cb);
    };
    return MMSImg;
}());
exports.MMSImg = MMSImg;
